export default __webpack_public_path__ + "static/media/success.18617036.gif";